export const EMAIL_LOGO_IMG_URL = "https://cyberspf.com/logo.png"